import { createReducer } from 'modules/app-core/redux-utils'
import t from './actionTypes'

// initialState
const initialState = {}

export default createReducer(initialState, {
  [t.RECEIVE_COMPANY]: (state, payload) => Object.assign({}, state, payload),
})
